import { useEffect } from "react";

/**
 * Хук для блокировки скролла страницы
 * @param {boolean} shouldLock - нужно ли заблокировать скролл
 * @param {Object} options - дополнительные опции
 * @param {boolean} options.lockOnMount - заблокировать при монтировании (по умолчанию false)
 */
export const useScrollLock = (shouldLock, options = {}) => {
  const { lockOnMount = false } = options;

  useEffect(() => {
    if (lockOnMount || shouldLock) {
      document.body.style.overflow = "hidden";

      if (window.innerWidth <= 768) {
        const scrollY = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
      }
    } else {
      const scrollY = document.body.style.top;
      document.body.style.overflow = "unset";
      document.body.style.position = "static";
      document.body.style.width = "auto";
      document.body.style.top = "";

      if (scrollY && window.innerWidth <= 768) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }

    return () => {
      document.body.style.overflow = "unset";
      document.body.style.position = "static";
      document.body.style.width = "auto";
      document.body.style.top = "";
    };
  }, [shouldLock, lockOnMount]);
};
